// extracted by mini-css-extract-plugin
export default {"InfoIcon":"styles_InfoIcon__CPCgj","blink-animation":"styles_blink-animation__pvj0k"};